// Rajesh 11/25/2022 2700423152 trigger execution table.
// Suresh Peddavoora 11/28/2022 2700423152 Modified Table Styles and Table Pagination
// Dilip 12/26/2022 2700423152 added error message column
// Suresh Peddavoora 12/27/2022 2700423152 Removed unneccesary code from styles
// Raghu 12/28/2022 2700423152 Table Footer Stylings
// manikanta 12/30/2022 2700423152 Disable download for inprogress status
// sai krishna 1/2/2023 2700423152 add trigger code and description for trigger exicution popup
// Ashraf 01/04/2023 2699234404 changed date format display
// Akhila 02/09/2023 2699234404 rename code and description in run execution
// Akhila 02/27/2023 2699234404 implemented preview file functionality
// Raghu 02/28/2023 2699234404 added new class for buttons
// Akhila 03/09/2023  2699234404 Added loader and download toast message
// Prakash 29/06/2023 2699234404 add pop up tooltip
// Akhila 06/07/2023 2699234404 added breadcrum code and description

import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import {
  resetTriggersData,
  postDownloadTrigger,
} from '../../../../redux/reducers/TriggerGroup';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import BreadCrums from '../../../../util/BreadCrum';
import {fetchDownloadSuccess} from '../../../../redux/reducers/PreviewFileData';


const triggerExecutionsTable = ({historyData}) => {
  const tableRef = createRef();
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'File Name',
      field: 'fileName',
    },
    {
      title: 'Status',
      field: 'status',
      render: (rowData) => (
        <span style={{color: rowData.status === 'SUCCESS' ? '#00af00' : '#FA113D'}}>
          {rowData.status}
        </span>
      ),
    },
    {
      title: 'Start Time',
      field: 'startDttm',
      render: (rowData) => (
        <>
          {rowData?.startDttm ?
            moment(rowData?.startDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm A') :
            ''}
          {/* {rowData?.startDttm && moment(rowData.startDttm).format("MM/DD/YYYY")}
          {` `}
          {rowData?.startDttm && moment(rowData.startDttm, "HH:mm").format("hh:mm A")} */}
        </>
      ),
    },
    {
      title: 'End Time',
      field: 'endDttm',
      render: (rowData) => (
        <>
          {rowData?.endDttm ?
            moment(rowData?.endDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm A') :
            ''}
          {/* {rowData?.endDttm && moment(rowData.endDttm).format("MM/DD/YYYY")}
          {` `}
          {rowData?.endDttm && moment(rowData.endDttm, "HH:mm").format("hh:mm A")} */}
        </>
      ),
    },
    {
      title: 'Executed By',
      field: 'executedBy',
    },
    {
      title: 'Error Message',
      field: 'errorMessage',
      cellStyle: {
        minWidth: 350,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.errorMessage?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.errorMessage?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // render: (rowData) => <span style={{ whiteSpace: "pre-wrap" }}>{rowData.errorMessage}</span>,
    },
  ];

  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);

  const {triggerExecutionData} = useSelector(
    ({addTriggerGroup}) => addTriggerGroup,
  );
  const triggerData =
    triggerExecutionData && triggerExecutionData?.length > 0 ?
      triggerExecutionData?.map((item) => ({
        ...item,
      })) :
      [];

  useEffect(() => {
    return () => {
      dispatch(resetTriggersData());
    };
  }, []);

  return (
    <div className="global-field-table custom-table col-12 new-standard-textfields">
      <BreadCrums
        name={'Batch Trigger Name'}
        code={historyData?.groupCode}
        description={'Description'}
        descriptionValue={historyData?.groupDescription}
      />
      <GuiTable
        title=""
        columns={columns}
        tableRef={tableRef}
        data={triggerData}
        actions={[
          (rowData) => {
            if (rowData?.documentKey) {
              return {
                icon: () => <GetAppOutlinedIcon />,
                tooltip: 'Download',
                disabled: rowData.status === 'IN_PROGRESS',
                onClick: (event, rowData) => {
                  dispatch(
                    postDownloadTrigger({
                      dockey: rowData?.documentKey,
                    }),
                  );
                  dispatch(
                    fetchDownloadSuccess({
                      response: 'Batch Triggers Execution Downloaded SuccessFully',
                    }),
                  );
                },
              };
            }
          },
        ]}
        options={{
          search: false,
          pageSize: rows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          toolbar: false,
          pageSizeOptions: tablePageRows,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
        components={{
          Pagination: (props) => (
            <div className="global-field-table-footer">
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            </div>
          ),
        }}
      />
    </div>
  );
};

export default triggerExecutionsTable;
